"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
exports.Menu = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({}, props, { fill: props.fill || common_styles_1.black, viewBox: "0 0 100 80", width: "40", height: "40" }),
    React.createElement("rect", { width: "100", height: "20", rx: "8" }),
    React.createElement("rect", { y: "30", width: "100", height: "20", rx: "8" }),
    React.createElement("rect", { y: "60", width: "100", height: "20", rx: "8" }))); };
//# sourceMappingURL=menu.js.map